const projectConfig = {
	enableAnalytics: true,
};

export default projectConfig;
